import React, { useState } from "react";
import { Link } from "react-router-dom";
import {Menu, X} from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-zinc-950 border-b border-zinc-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3">
            <div className="text-3xl font-bold">
              <span className="text-orange-500">MULE</span>
              <span className="text-white">SHED.COM</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Home
            </Link>
            <Link to="/products" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Products
            </Link>
            <Link to="/blog" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Blog
            </Link>
            <Link to="/buying-guide" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Buying Guide
            </Link>
            <Link to="/safety" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Safety
            </Link>
            <Link to="/maintenance" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Maintenance
            </Link>
            <Link to="/faq" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              FAQ
            </Link>
            <Link to="/comparison" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Compare
            </Link>
            <Link to="/contact" className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              Contact
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-300 hover:text-orange-500">

            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen &&
        <div className="md:hidden pb-4 space-y-2">
            <Link
            to="/"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Home
            </Link>
            <Link
            to="/products"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Products
            </Link>
            <Link
            to="/blog"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Blog
            </Link>
            <Link
            to="/buying-guide"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Buying Guide
            </Link>
            <Link
            to="/safety"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Safety
            </Link>
            <Link
            to="/maintenance"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Maintenance
            </Link>
            <Link
            to="/faq"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              FAQ
            </Link>
            <Link
            to="/privacy"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Privacy Policy
            </Link>
            <Link
            to="/comparison"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Compare Equipment
            </Link>
            <Link
            to="/contact"
            className="block text-gray-300 hover:text-orange-500 py-2 transition-colors"
            onClick={() => setIsOpen(false)}>

              Contact
            </Link>
          </div>
        }
      </div>
    </nav>);

};

export default Navbar;